import { useCallback } from 'react';
import { ValidatorType } from '@vp/upload-and-print-validator';
import { PERFECT_BOUND_PDF_COVER_PAGE_COUNT, PERFECT_BOUND_PRODUCT_KEYS } from 'src/utils/Constants';
import { ValidationErrorDataType } from 'src/utils/validationErrorsMessage';
import { useProductContext } from './ProductContextHooks';

export const usePerfectBound = () => {
  const { productInformation } = useProductContext();

  const isPerfectBound = PERFECT_BOUND_PRODUCT_KEYS.includes(productInformation.productKey);

  /**
   * If the product is perfect bound, add 2 pages to the documentPageCount (page count of uploaded file)
   * because a perfect bound uploaded file should have first 2 pages double the size of other pages for cover.
   */
  const getPerfectBoundPageCountTokenValues = useCallback(
    (item: ValidationErrorDataType) => {
      let tokenValues = item.tokenValues;
      if (isPerfectBound && item.id === ValidatorType.PageCountValidator && item.tokenValues?.documentPageCount) {
        const perfectBoundDocPageCount = parseInt(item.tokenValues.documentPageCount);
        tokenValues = {
          ...item.tokenValues,
          documentPageCount: (perfectBoundDocPageCount + PERFECT_BOUND_PDF_COVER_PAGE_COUNT).toString(),
        };
      }

      return tokenValues;
    },
    [isPerfectBound]
  );

  return { isPerfectBound, getPerfectBoundPageCountTokenValues };
};
